import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { ExportComponent } from './export.component';

const routes: Routes = Route.withShell([
  { path: 'export', component: ExportComponent, data: { title: 'Export' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class ExportRoutingModule { }
